function urltimer() {
	return '?t=' + Math.floor(new Date().getTime() / 60000);
}

const cache_db = {};
const cache_list = [];
function cacheImage(src) {
	/* src = src.replace('cdnydm', 'cdy.yapaytech'); */
	if (cache_db[src]) return Promise.resolve(cache_db[src]);
	let img = new window.Image();
	let _src = src.indexOf('/img') === -1 ? src.replace('wg.dialogtab.com/', 'wg.dialogtab.com/proxy/insecure/q:40/plain/local:///') + urltimer() : src;
	img.src = _src;
	//img.crossOrigin = 'anonymous';
	return (cache_db[src] = new Promise((resolve) => {
		img.onload = function () {
			cache_db[src] = img;
			cache_list.push(src);
			resolve(img);
			if (cache_list.length > 50) {
				let _remove = cache_list.shift();
				delete cache_db[_remove];
			}
		};
		img.onerror = function (e) {
			let _src = src.indexOf('/img') === -1 ? src.replace('wg.dialogtab.com/', 'cdn.whatsapp-shop.com/') : src;
			img.onerror = function (e) {
				let newsrc = `https://cdnydm.com/proxy/cors?uri=${encodeURIComponent(src)}`;
				if (img.src !== newsrc) img.src = newsrc;
			};
			let newsrc = _src;
			if (img.src !== newsrc) img.src = newsrc;
		};
	}));
}

function calculateMinRatio(it) {
	let xr = it.image.width / it.width,
		yr = it.image.height / it.height;
	let min = 1;
	if (xr > yr) min = it.height / it.image.height;
	else min = it.width / it.image.width;
	it.min = min;
	return min;
}

function genDefault(raw, i, _) {
	let sema = raw.images[i];
	if (!sema) return null;
	let min = calculateMinRatio({ image: _, width: sema.width, height: sema.height });
	let rw = sema.width / min,
		rh = sema.height / min;
	let xc = (_.width - rw) / 2,
		yc = (_.height - rh) / 2;
	return {
		__ws: true,
		id: i.toString(),
		image: _,
		x: sema.x,
		y: sema.y,
		width: sema.width,
		height: sema.height,
		isDragging: false,
		crop: { x: xc, y: yc, width: sema.width / min, height: sema.height / min },
		scale: min,
		min,
	};
}

function generateShapes(_images, raw, list) {
	return _images
		.map((_, i) => {
			let data = genDefault(raw, i, _);
			data.src = list[i];
			return data;
		})
		.filter(Boolean);
}

function fillImage(it, src) {
	return cacheImage(src).then((image) => {
		it.image = image;
		it.src = src;
		it.scale = it.scale || calculateMinRatio(it);
		it.min = it.min || calculateMinRatio(it);
	});
}

export { urltimer, cacheImage, calculateMinRatio, genDefault, generateShapes, fillImage };
